
import Vue, { PropType } from "vue";
import { Auth, setLocale, SupportedLocales, apiStats, graphqlStats } from "@/@core";
import { ConfigToolbar, MainMenuItem } from "@/@shell/components/BaseToolbar/interfaces/Toolbar";
import { drawerRightState } from "@/@shell/components/store/drawerRightState";
import { drawerState } from "@/@shell/components/store/drawerState";
import DynamicToolbar from "@/@shell/components/BaseToolbar/Index.vue";

export default Vue.extend({
  components: {
    DynamicToolbar,
  },
  props: {
    config: {
      type: Object as PropType<ConfigToolbar>,
    },
    canLogOut: {
      type: Boolean,
      default: true,
    },
    headerNeedRefresh: {
      type: Boolean,
      required: false,
    },
    menu: {
      type: Array as PropType<MainMenuItem[]>,
    },
  },
  data() {
    return {
      apiStats,
      drawerState,
      drawerRightState,
      graphqlStats,
      appBarEl: null as null | HTMLElement,
      appLogo: `${process.env.BASE_URL}img/logo-white.svg`,
      headerSize: 0,
      isDrawerShown: false,
      isNavDrawerCollapsed: false,
      isNavDrawerRightCollapsed: true,
      locales: SupportedLocales,
      userName: undefined,
    };
  },
  computed: {
    cssVars(): object {
      return {
        "--drawer-right-trigger_left": drawerRightState.triggerStyle.left,
        "--drawer-trigger_before-bg-color": drawerState.triggerStyle.beforeBackgroundColor,
        "--drawer-trigger_before-size": drawerState.triggerStyle.beforeSize,
        "--drawer-trigger_right": drawerState.triggerStyle.right,
        "--drawer-trigger_size": drawerState.triggerStyle.size,
      };
    },
    drawerRightStyle(): object {
      const style = this.cssVars;
      if (this.appBarEl) {
        Object.assign(style, {
          maxHeight: `calc(100% - ${this.appBarEl.offsetHeight}px)`,
          top: `${this.appBarEl?.offsetHeight}px`,
        });
      }
      return style;
    },
    hasDrawer(): boolean {
      return (
        !!(this.$scopedSlots.drawer || this.$slots.drawer) &&
        (drawerState.isRouteWithDisplayState(this.$route) ? drawerState.isVisible : true)
      );
    },
    hasDrawerRight(): boolean {
      return (
        !!(this.$scopedSlots.drawerRight || this.$slots.drawerRight) &&
        (drawerRightState.isRouteWithDisplayState(this.$route) ? drawerRightState.isVisible : true)
      );
    },
    isDrawerCollapsed(): boolean {
      return drawerState.isRouteWithDisplayState(this.$route) ? drawerState.isCollapsed : this.isNavDrawerCollapsed;
    },
    isDrawerRightCollapsed(): boolean {
      return drawerRightState.isRouteWithDisplayState(this.$route)
        ? drawerRightState.isCollapsed
        : this.isNavDrawerRightCollapsed;
    },
  },
  created() {
    window.addEventListener("resize", this.refreshHeader);
  },
  destroyed() {
    window.removeEventListener("resize", this.refreshHeader);
  },
  updated() {
    this.refreshHeader();
  },
  async mounted() {
    this.refreshHeader();
    this.$nextTick(() => {
      this.appBarEl = (this.$refs.appBar as Vue).$el as HTMLElement;
    });
    this.userName = await Auth.getClaim("given_name");
  },
  methods: {
    handleDrawerCollapse() {
      if (drawerState.isRouteWithDisplayState(this.$route)) {
        drawerState.isCollapsed = !drawerState.isCollapsed;
      } else {
        this.isNavDrawerCollapsed = !this.isNavDrawerCollapsed;
      }
    },
    handleDrawerRightCollapse() {
      if (drawerRightState.isRouteWithDisplayState(this.$route)) {
        drawerRightState.isCollapsed = !drawerRightState.isCollapsed;
      } else {
        this.isNavDrawerRightCollapsed = !this.isNavDrawerRightCollapsed;
      }
    },
    logOut() {
      Auth.logOut();
    },
    refreshHeader() {
      this.headerSize =
        (document.getElementById("toolbar")?.clientHeight || 0) +
        (document.getElementById("header")?.clientHeight || 0);
    },
    setLocale(l: string) {
      setLocale(l);
      this.$vuetify.lang.current = l;
    },
    showDrawer() {
      this.isDrawerShown = !this.isDrawerShown;
    },
  },
  watch: {
    headerNeedRefresh: {
      handler(newVal) {
        if (newVal === true) {
          Object.assign(this.cssVars, {
            maxHeight: `calc(100% - ${this.appBarEl?.offsetHeight}px)`,
            top: `${this.appBarEl?.offsetHeight}px`,
          });
          this.$emit("resetHeaderNeedRefresh");
        }
      },
    },
  },
});
